<i18n
  src="@/locales/views/service_provider/tech_visit/reporting/home.yml"
  lang="yaml"
></i18n>
<template>
  <bread-crumbs :labels="[module_name]" />

  <div class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">Reporte detallado</h3>
      </div>
      <div class="panel-body">
        <div class="grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-4">
          <div class="col-span-1">
            <label class="label-form">
              {{ $t("labels.tech_visit_form_id") }}
            </label>
            <div class="mt-1">
              <select-form
                :options="tech_visit_forms"
                v-model="filtersDetailed.tech_visit_form_id"
              ></select-form>
            </div>
          </div>
          <div class="col-span-1">
            <label class="label-form">
              {{ $t("labels.crop_field_id") }}
            </label>
            <div class="mt-1">
              <select-form
                :options="crop_fields"
                v-model="filtersDetailed.crop_field_id"
              ></select-form>
            </div>
          </div>
          <div class="col-span-1">
            <label class="label-form">
              {{ $t("labels.from_date") }}
            </label>
            <div class="mt-1">
              <date-form v-model="filtersDetailed.from_date"></date-form>
            </div>
          </div>
          <div class="col-span-1">
            <label class="label-form">
              {{ $t("labels.to_date") }}
            </label>
            <div class="mt-1">
              <date-form v-model="filtersDetailed.to_date"></date-form>
            </div>
          </div>
        </div>
      </div>
      <div class="py-2 px-4">
        <div class="panel-footer-actions">
          <white-button
            :label="$t('labels.download_report')"
            :disabled="!validateFilterDetailedParams"
            :icon="'fas fa-download'"
            @click.prevent="downloadReportDetailed"
          />
        </div>
      </div>
    </div>
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">Reporte solo preguntas relevantes</h3>
      </div>
      <div class="panel-body">
        <div class="grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-4">
          <div class="col-span-1">
            <label class="label-form">
              {{ $t("labels.tech_visit_form_id") }}
            </label>
            <div class="mt-1">
              <select-form
                :options="tech_visit_forms"
                v-model="filtersRelevants.tech_visit_form_id"
              ></select-form>
            </div>
          </div>
          <div class="col-span-1">
            <label class="label-form">
              {{ $t("labels.from_date") }}
            </label>
            <div class="mt-1">
              <date-form v-model="filtersRelevants.from_date"></date-form>
            </div>
          </div>
          <div class="col-span-1">
            <label class="label-form">
              {{ $t("labels.to_date") }}
            </label>
            <div class="mt-1">
              <date-form v-model="filtersRelevants.to_date"></date-form>
            </div>
          </div>
        </div>
      </div>
      <div class="py-2 px-4">
        <div class="panel-footer-actions">
          <white-button
            :label="$t('labels.download_report')"
            :disabled="!validateFilterRelevantParams"
            :icon="'fas fa-download'"
            @click.prevent="downloadReportRelevants"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Requester from "@/views/service_provider/requesters/tech_visits/reporting/home.js";
export default {
  name: "SPTechVisitsReportingHome",
  components: {},
  data() {
    return {
      tech_visit_forms: [],
      crop_fields: [],
      filtersDetailed: {
        tech_visit_form_id: "",
        from_date: this.firstDayOfLastYear(),
        to_date: moment().format("YYYY-MM-DD"),
        crop_field_id: ""
      },
      filtersRelevants: {
        tech_visit_form_id: "",
        from_date: this.firstDayOfLastYear(),
        to_date: moment().format("YYYY-MM-DD"),
      },
      downloading: false
    };
  },
  props: {
    service_provider_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id
        }
      }).then(() => this.loadData())
    );
  },
  computed: {
    validateFilterDetailedParams: function () {
      return (
        this.filtersDetailed.tech_visit_form_id &&
        this.filtersDetailed.crop_field_id &&
        this.filtersDetailed.from_date &&
        this.filtersDetailed.to_date
      );
    },

    validateFilterRelevantParams: function () {
      return (
        this.filtersRelevants.tech_visit_form_id &&
        this.filtersRelevants.from_date &&
        this.filtersRelevants.to_date
      );
    }
  },
  methods: {
    loadData: async function () {
      this.fetchTechVisitForms();
      this.fetchCropFields();
    },

    fetchTechVisitForms: async function () {
      let response = await Requester.fetchTechVisitForms(
        this.service_provider_id
      );
      this.tech_visit_forms = response.data;
      if (this.tech_visit_forms.length == 1) {
        this.filtersDetailed.tech_visit_form_id = this.tech_visit_forms[0].id;
        this.filtersRelevants.tech_visit_form_id = this.tech_visit_forms[0].id;
      }
    },

    fetchCropFields: async function () {
      let response = await Requester.fetchCropFields(this.service_provider_id);
      this.crop_fields = response.data;
    },

    downloadReportDetailed: async function () {
      this.downloading = true;
      try {
        const response = await Requester.downloadReportDetailed(
          this.service_provider_id,
          this.filtersDetailed
        );
        let file = response.data;
        this.downloadFile(file, `Reporte-Detallado.${(file.type == "application/pdf") ? "pdf" : "xlsx"}`);
      } catch (error) {
        error;
      }
      this.downloading = false;
    },

    downloadReportRelevants: async function () {
      this.downloading = true;
      try {
        const response = await Requester.downloadReportRelevants(
          this.service_provider_id,
          this.filtersRelevants
        );
        let file = response.data;
        this.downloadFile(file, `Reporte-Relevantes.xlsx`);
      } catch (error) {
        error;
      }
      this.downloading = false;
    },

    firstDayOfLastYear: function () {
      return moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD");
    }
  }
};
</script>
